import { observer } from 'mobx-react-lite'
import { links } from '@/utils/link'
import { type UserDetailsViewModel } from '@/features/user-management/UserDetails/UserDetailsViewModel'
import { UserDetailsInformation } from '@/features/user-management/components/UserDetailsInformation'
import { getProviderPtinStatusText } from '@/features/iam/providers/provider-display'
import { ClientUserAdvisorsContainer } from '@/features/client-user-management/components/ClientUserDetailsInformation/ClientUserAdvisorsContainer'

export interface UserDetailsInformationContainerProps {
  vm: UserDetailsViewModel
}

export const UserDetailsInformationContainer = observer(
  function UserDetailsInformationContainer({
    vm,
  }: UserDetailsInformationContainerProps) {
    return (
      <>
        <UserDetailsInformation
          displayName={vm.user.displayName}
          email={vm.user.email}
          phone={vm.user.phone}
          publicId={vm.user.publicId ?? ''}
          activeJobs={vm.activeJobs}
          totalJobs={vm.totalJobs}
          lastSeen={vm.user.lastSeen}
          dateModified={vm.user.dateModified}
          dateCreated={vm.user.dateCreated}
          legacyUserId={vm.user.userId ?? ''}
          paymentMethodLast4s={vm.paymentMethods.map((pm) =>
            'last4' in pm.type ? pm.type.last4 : '',
          )}
          userDataType={vm.user.userDataType}
          payoutMethodStatus={vm.payoutMethodInfo.status}
          payoutStripeAccountId={vm.payoutStripeAccountId}
          canEditUserInformation={vm.canEditUserInformation}
          onEditUserInformation={vm.editUserInformation}
          isPro={vm.isUserDataTypePro}
          isPlatformAdmin={vm.isPlatformAdmin}
          onEditProDetails={vm.editProDetails}
          globalJobCapacity={vm.provider.globalJobCapacity}
          stateRegion={vm.provider.stateRegion}
          ptinStatus={getProviderPtinStatusText(vm.provider.activePtin)}
          yearsExperience={vm.provider.yearsExperience}
          softwareOwnedCount={vm.provider.softwareOwned.length}
          softwareExperienceCount={vm.provider.softwareExperience.length}
          specialtiesCount={vm.provider.specialties.length}
          onEditGlobalCapacity={vm.editGlobalCapacity}
          onViewSoftwareOwned={vm.showSoftwareOwned}
          onViewSoftwareExperience={vm.showSoftwareExperience}
          onViewSpecialties={vm.showSpecialties}
        />
        {vm.clientAssignmentVm.shouldShowAdvisors && (
          <ClientUserAdvisorsContainer
            vm={vm.clientAssignmentVm}
            getAdvisorLink={links.userDetails}
          />
        )}
      </>
    )
  },
)
